import { render, staticRenderFns } from "./crosstabTable.vue?vue&type=template&id=0398b5de&scoped=true"
import script from "./crosstabTable.vue?vue&type=script&lang=js"
export * from "./crosstabTable.vue?vue&type=script&lang=js"
import style0 from "./crosstabTable.vue?vue&type=style&index=0&id=0398b5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398b5de",
  null
  
)

export default component.exports